import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Modal, Button, Form, Col, Row, InputGroup, Container, Table } from '@themesberg/react-bootstrap'
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import moment from "moment-timezone";
import { Context } from '../..'
import { useCookies } from 'react-cookie';
import { upload } from '../../controller';

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const [departDate, setDepartDate] = useState('');
  const [departTime, setDepartTime] = useState('');
  const [routeName, setRouteName] = useState('');
  const [boatName, setBoatName] = useState('');
  const [seatName, setSeatName] = useState('');
  const [price, setPrice] = useState('');

  const [cookies] = useCookies(['wvivu'])

  const [image, setImage] = useState(undefined);

  const _departDate = useRef('')
  const _departTime = useRef('')

  useEffect(() => {
    if (state.updatePopup.show) {
      setRouteName(state.updatePopup.routeName)
      setBoatName(state.updatePopup.boatName)
      setSeatName(state.updatePopup.seatName)
      setPrice(state.updatePopup.price)
      _departTime.current = state.updatePopup.departTime
      setDepartTime(state.updatePopup.departTime)
      _departDate.current = state.updatePopup.departDate
      setDepartDate(state.updatePopup.departDate)
      console.log(_departDate.current, _departTime.current)
    } else {
      setDepartDate('')
      setDepartTime('')
      setRouteName('')
      setBoatName('')
      setSeatName('')
      setPrice('')
      _departTime.current = undefined
    }
  }, [
    state.updatePopup.show,
    state.updatePopup.departDate,
    state.updatePopup.departTime,
    state.updatePopup.routeName,
    state.updatePopup.boatName,
    state.updatePopup.seatName,
    state.updatePopup.price,
  ])

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_UPDATE_POPUP',
      payload: {
        confirmed: false,
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    if (image) {
      dispatch({
        type: 'CLOSE_UPDATE_POPUP',
        payload: {
          confirmed: true,
          departDate: moment(departDate).format("DD/MM/YYYY"),
          departTime: moment(departTime).format("HH:mm"),
          routeName: routeName,
          boatName: boatName,
          seatName: seatName,
          price: price,
          image: image,
        },
      })
      setImage(undefined)
    } else {
      alert('Hãy up file vé')
    }
  }, [
    image,
    departDate,
    departTime,
    routeName,
    boatName,
    seatName,
    price,
  ])

  const onChangeRoute = useCallback((payload) => {
    setRouteName(payload.target.value)
  }, [])

  const onChangeDepartDate = useCallback((payload) => {
    _departDate.current = payload
    setDepartDate(payload)
  }, [])

  const onChangeDepartTime = useCallback((payload) => {
    _departTime.current = payload
    setDepartTime(payload)
  }, [])

  const onChangeBoat = useCallback((payload) => {
    setBoatName(payload.target.value)
  }, [])

  const onChangeSeat = useCallback((payload) => {
    setSeatName(payload.target.value)
  }, [])

  const onChangePrice = useCallback((payload) => {
    setPrice(parseInt(payload.target.value))
  }, [])

  const uploadFunc = useCallback(async (file) => {

    const response = await upload(cookies.wvivu, state.updatePopup.id, 'ticket', file)
    setImage(response)
  }, [
    cookies.wvivu,
    state.updatePopup.id
  ])

  const onImageChange = (evt) => {
    if (evt.target.files[0]) {
      uploadFunc(evt.target.files[0])
    }
  }

  return (
    <Modal as={Modal.Dialog} centered show={state.updatePopup.show} size='xl' fullscreen onHide={(handleClose)}>
      <Modal.Header>
        <Modal.Title className="h6">Xuất vé</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Col>
            <Row className='p-1'>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Tuyến</Form.Label>
                  </Col>
                  <Col md={9}>
                    {state.updatePopup.routeName && <Form.Select defaultValue={state.updatePopup && state.updatePopup.routeName} onChange={onChangeRoute}>
                      {state.filterCondition.listRoute.map(i => {
                        return <option key={i.id + '-route'} value={i.name}>{i.name}</option>
                      })}
                    </Form.Select>
                    }
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Ngày khởi hành</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      dateFormat="DD/MM/YYYY"
                      timeFormat={false}
                      initialValue={state.updatePopup.departDate ? moment(state.updatePopup.departDate).format("DD/MM/YYYY") : ""}
                      onChange={onChangeDepartDate}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={_departDate.current ? moment(_departDate.current).format("DD/MM/YYYY") : ""}
                            placeholder="dd/mm/yyyy"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Tàu</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Select defaultValue={state.updatePopup.boatName} onChange={onChangeBoat}>
                      {state.filterCondition.listBoat.map(i => {
                        return <option key={i.id + '-boat'} value={i.name}>{i.name}</option>
                      })}
                    </Form.Select>
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Giờ khởi hành</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Datetime
                      dateFormat={false}
                      timeFormat="HH:mm"
                      initialValue={state.updatePopup.departTime ? moment(state.updatePopup.departTime).format("HH:mm") : ""}
                      onChange={onChangeDepartTime}
                      renderInput={(props, openCalendar) => (
                        <InputGroup>
                          <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                          <Form.Control
                            required
                            type="text"
                            value={_departTime.current ? moment(_departTime.current).format("HH:mm") : ""}
                            placeholder="HH:mm"
                            onFocus={openCalendar}
                            onChange={() => { }} />
                        </InputGroup>
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className='p-1'>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Ghế</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangeSeat} defaultValue={state.updatePopup.seatName} required type="text" placeholder="Nhập ghế" />
                  </Col>
                </Row>
              </Col>
              <Col sm={12} md={6}>
                <Row>
                  <Col md={3} className='text-left align-self-center'>
                    <Form.Label>Giá vé</Form.Label>
                  </Col>
                  <Col md={9}>
                    <Form.Control onChange={onChangePrice} defaultValue={state.updatePopup.price} required type="text" placeholder="Nhập giá vé" />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Container>
        <div style={{ marginBottom: 20 }}></div>
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thông tin</th>
              <th scope="col">Giá trị cũ</th>
              <th scope="col">Giá trị mới</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className='text-center'>Tuyến</th>
              <td className='text-center'>
                {routeName == state.updatePopup.routeName
                  ?
                  state.updatePopup.routeName
                  :
                  <strong className='text-danger'>{state.updatePopup.routeName}</strong>
                }
              </td>
              <td className='text-center'>
                {routeName == state.updatePopup.routeName
                  ?
                  routeName
                  :
                  <strong className='text-success'>{routeName}</strong>
                }
              </td>
            </tr>
            <tr>
              <th className='text-center'>Tàu</th>
              <td className='text-center'>
                {boatName == state.updatePopup.boatName
                  ?
                  state.updatePopup.boatName
                  :
                  <strong className='text-danger'>{state.updatePopup.boatName}</strong>
                }
              </td>
              <td className='text-center'>
                {boatName == state.updatePopup.boatName
                  ?
                  boatName
                  :
                  <strong className='text-success'>{boatName}</strong>
                }
              </td>
            </tr>
            <tr>
              <th className='text-center'>Ngày khởi hành</th>
              <td className='text-center'>
                {moment(departDate).format("DD/MM/YYYY") == moment(state.updatePopup.departDate).format("DD/MM/YYYY")
                  ?
                  moment(state.updatePopup.departDate).format("DD/MM/YYYY")
                  :
                  <strong className='text-danger'>{moment(state.updatePopup.departDate).format("DD/MM/YYYY")}</strong>
                }
              </td>
              <td className='text-center'>
                {moment(departDate).format("DD/MM/YYYY") == moment(state.updatePopup.departDate).format("DD/MM/YYYY")
                  ?
                  moment(departDate).format("DD/MM/YYYY")
                  :
                  <strong className='text-success'>{moment(departDate).format("DD/MM/YYYY")}</strong>
                }
              </td>
            </tr>
            <tr>
              <th className='text-center'>Giờ khởi hành</th>
              <td className='text-center'>
                {moment(departTime).format("HH:mm") == moment(state.updatePopup.departTime).format("HH:mm")
                  ?
                  moment(state.updatePopup.departTime).format("HH:mm")
                  :
                  <strong className='text-danger'>{moment(state.updatePopup.departTime).format("HH:mm")}</strong>
                }
              </td>
              <td className='text-center'>
                {moment(departTime).format("HH:mm") == moment(state.updatePopup.departTime).format("HH:mm")
                  ?
                  moment(departTime).format("HH:mm")
                  :
                  <strong className='text-success'>{moment(departTime).format("HH:mm")}</strong>
                }
              </td>
            </tr>
            <tr>
              <th className='text-center'>Ghế</th>
              <td className='text-center'>
                {seatName.trim() == state.updatePopup.seatName
                  ?
                  state.updatePopup.seatName
                  :
                  <strong className='text-danger'>{state.updatePopup.seatName}</strong>
                }
              </td>
              <td className='text-center'>
                {seatName.trim() == state.updatePopup.seatName
                  ?
                  seatName.trim()
                  :
                  <strong className='text-success'>{seatName.trim()}</strong>
                }
              </td>
            </tr>
            <tr>
              <th className='text-center'>Giá vé</th>
              <td className='text-center'>
                {price == state.updatePopup.price
                  ?
                  new Intl.NumberFormat('vn-VI', {}).format(state.updatePopup.price) || ""
                  :
                  <strong className='text-danger'>{new Intl.NumberFormat('vn-VI', {}).format(state.updatePopup.price) || ""}</strong>
                }
              </td>
              <td className='text-center'>
                {price == state.updatePopup.price
                  ?
                  new Intl.NumberFormat('vn-VI', {}).format(price) || ""
                  :
                  <strong className='text-success'>{new Intl.NumberFormat('vn-VI', {}).format(price) || ""}</strong>
                }
              </td>
            </tr>
          </tbody>
        </Table>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Vé vật lý</Form.Label>
                <Form.Control placeholder='Vé vật lý' required type="file" onChange={onImageChange} />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {image ? 'Xong' : ''}
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Xác nhận
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)